module.exports = __webpack_public_path__ + "img/icone-local.54569a36.svg";